import { useState } from "react"

import { type Auth0User } from "~/server/api/routers/auth0"
import { api } from "~/utils/api"
import { DateFormatType, formatDate } from "~/utils/datetime"

import { Popover, PopoverContent, PopoverTrigger } from "../reusable/Popover"
import { Info } from "@phosphor-icons/react"

type Props = {
  user: Auth0User
}

export const UserPopover = ({ user }: Props) => {
  const [open, setOpen] = useState(false)

  const { data: fullUser } = api.auth0.getUser.useQuery({ userId: user.user_id }, { enabled: open })

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger>
        <Info className="h-5 w-5 text-fg-subtle" />
      </PopoverTrigger>
      <PopoverContent className="w-128 p-0" side="left" collisionPadding={20}>
        <div className="flex flex-col rounded-lg">
          <div className="bg-medium p-6 rounded-t-md font-medium">User Information</div>
          <div className="flex flex-col text-sm p-6 pt-4 gap-2">
            <div className="text-sm text-fg-subtle">
              PS. Only Hakio employees can access this popup
            </div>
            <div>
              <span className="font-medium">Name:</span> {fullUser?.name}
            </div>
            <div>
              <span className="font-medium">Email:</span> {fullUser?.email}
            </div>
            <div>
              <span className="font-medium">Logins count:</span> {fullUser?.logins_count}
            </div>
            <div>
              <span className="font-medium">Last login:</span>{" "}
              {formatDate(fullUser?.last_login, DateFormatType.WithTime)}
            </div>
            <div>
              <span className="font-medium">Login providers:</span>{" "}
              {fullUser?.identities?.map((i) => i.provider).join(", ")}
            </div>
            <div>
              <span className="font-medium">Added at:</span>{" "}
              {formatDate(fullUser?.created_at, DateFormatType.WithTime)}
            </div>
            <div>
              <span className="font-medium">Updated at:</span>{" "}
              {formatDate(fullUser?.updated_at, DateFormatType.WithTime)}
            </div>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  )
}
